import { render, staticRenderFns } from "./generalTemplate.vue?vue&type=template&id=bddc117c&scoped=true&"
import script from "./generalTemplate.vue?vue&type=script&lang=js&"
export * from "./generalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddc117c",
  null
  
)

export default component.exports